import React from "react";
import {connect} from "react-redux";
import {Route, Redirect} from "react-router-dom";

// Normally the args of the PrivateRoute will have the default args as props
// But if the props is being destructuring, then if we use a name that match the name of any
// Variable inside the props, then that variable will be pull out of the props
// And it still have the original data, no matter the order of the variable inside the props

export const PrivateRoute = ({isAuthenticated, component: Component, ...rest}) => {
   // console.log({...rest});
   return (
       <Route {...rest} component={(props) => {
          // console.log(props);
          return (
                isAuthenticated ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/" />
                )
            );
         }}
       />
   );
};

// Look into the function below we can see the Component accept a props from the parents
// For example <Route component={Edit_Transaction_Page}
// The JS syntax allow just only need to call the name without any parameter because
// At first the parameter will be define at the Component definition
// Second it explain the reason why in the function above, we need to manually pass the props into
// The component and we use the spread operator {...props} in the child element
// This is because the Component is not directly be a child of the component
// Therefore, we need to do it manually in order to pass down all the props into it

// const Edit_Transaction_Page = (props) => {
//    return (
//        <div>
//           <Transaction_Form
//               Transaction={props.Transaction}
//               onSubmit={(transaction) => {
//                  props.Update_Transaction_With_Firebase(props.Transaction.id, transaction);
//                  props.history.push("/");
//               }}
//               button_name="Edit Transaction"
//               form_name="Edit Transaction"
//           />
//        </div>
//    );
// };

const mapStateToProps = (state) => ({
   isAuthenticated: !!state.Auth.uid
});

export default connect(mapStateToProps)(PrivateRoute);